var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.selectedTab.type == _vm.ItemCategoryTypes.SUBL ||
    _vm.selectedViewType != _vm.viewTypes.tabbedView
      ? _c(
          "div",
          { staticClass: "mb-4" },
          [
            _c("quote-builder-sublet-headings-component", {
              attrs: {
                name: _vm.sublCategoryObject?.displayName || "Sublets",
                count: _vm.subletLength,
                "total-amount": _vm.subletsTotal,
                "is-full-width": _vm.isFullWidth,
              },
            }),
            _c(
              "div",
              { staticClass: "rows" },
              [
                _c(
                  "draggable",
                  _vm._b(
                    {
                      attrs: {
                        clone: ($event) =>
                          _vm.cloneHandler($event, _vm.ItemCategoryTypes.SUBL),
                        group: {
                          name: _vm.ItemCategoryTypes.SUBL,
                          pull: "clone",
                          put: true,
                        },
                        handle: ".item-drag-handle",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.itemMoved(
                            $event,
                            _vm.ItemCategoryTypes.SUBL
                          )
                        },
                        over: function ($event) {
                          $event.preventDefault()
                        },
                        enter: function ($event) {
                          $event.preventDefault()
                        },
                      },
                      model: {
                        value: _vm.innerValue.sublets,
                        callback: function ($$v) {
                          _vm.$set(_vm.innerValue, "sublets", $$v)
                        },
                        expression: "innerValue.sublets",
                      },
                    },
                    "draggable",
                    {
                      disabled: !_vm.isRowDraggable,
                      chosen: "chosen",
                      ghostClass: "draggable-ghost",
                      dragClass: "draggable-drag",
                    },
                    false
                  ),
                  _vm._l(_vm.subletItems, function (item) {
                    return _c("quote-builder-sublet-item", {
                      key: item.id,
                      attrs: {
                        "inner-value": _vm.innerValue,
                        "is-full-width": _vm.isFullWidth,
                        "items-assessments": _vm.itemsAssessments,
                        item: item,
                        "edit-item-id": _vm.editItemObj.id,
                        vehicle: _vm.vehicle,
                        sublets: _vm.sublets,
                        vendors: _vm.vendors,
                        "is-editable": !_vm.readOnlyComputed,
                      },
                      on: {
                        deleteItem: (item) => _vm.deleteItem(item),
                        focusNextRow: function ($event) {
                          return _vm.$emit("focusNextRow", item)
                        },
                        handlePresentAs: (itemId) =>
                          _vm.$emit("handlePresentAs", itemId),
                        itemRowClicked: (value, event, close) =>
                          _vm.$emit("handleItemRowClick", value, event, close),
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "button is-outlined is-primary",
                  attrs: { disabled: _vm.readOnlyComputed },
                  on: {
                    click: function ($event) {
                      return _vm.addBlankItem()
                    },
                  },
                },
                [_vm._v(" + Add Item ")]
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }